import Cookies from 'js-cookie'

const TokenKey = 'fangche_token'
const FlashTokenKey = 'flash_token'

export function getToken() {
  return Cookies.get(TokenKey)
}
export function getFlashToken() {
  return Cookies.get(FlashTokenKey)
}
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function setFlashToken(token) {
  return Cookies.set(FlashTokenKey, token)
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}
